import { TableCell } from '@mui/material';
import { QuickFilterScope } from '../../../enums/quick-filters';
import { IQuickFilter } from '../../../interfaces/common/quick-filters';

export interface SortingByColumnState {
  column: string;
  order: 'increasing' | 'decreasing';
}

export const downArrow = '↓';
export const upArrow = '↑';

export interface CenteredTableCellProps {
  children: React.ReactNode;
  cursor?: boolean;
  padding?: string;
  colSpan?: number;
}

export function CenteredTableCell({
  children,
  cursor,
  padding,
  colSpan,
}: CenteredTableCellProps) {
  return (
    <TableCell
      align="center"
      style={{ cursor: cursor ? 'pointer' : '', padding: padding }}
      colSpan={colSpan ?? 1}
    >
      {children}
    </TableCell>
  );
}

export interface ColumnConfig<T> {
  header: React.ReactNode;
  display_body: (item: T) => React.ReactNode;
  id: string;
  hidden?: boolean;
}

export interface GenericTableProps<T> {
  items: T[];
  selectedItems: Map<string, T>;
  updateSelectedItems?: (updater: (draft: Map<string, T>) => void) => void;
  isLoading: boolean;
  columns: ColumnConfig<T>[];
  getItemUID: (item: T) => string;
  rowStyles?: (item: T) => React.CSSProperties;
  selectionEnabled?: boolean;
  fullWidth?: boolean;
  quickFiltersScope?: QuickFilterScope;
  applyQuickFilter?: (quickFilter: IQuickFilter | null) => void;
  sourceView: string;
}
